// Wrap in IIFE to avoid global scope pollution and variable conflicts
(function() {
    const header_menu_desktop = document.querySelector('.header-menu-desktop');

    const toggleSideMenu = () => {
        const menu_mobile = document.querySelector(`#main-mobile-menu`)
        const menuButton = document.querySelector(`[aria-controls="main-mobile-menu"]`);
        const isOpen = menu_mobile.classList.contains("open");
        
        menu_mobile.classList.toggle("open");
        
        // Update aria-expanded on the menu button
        if (menuButton) {
            menuButton.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        }
        
        if(!isOpen) {
            document.body.style.overflow= "hidden";
            // Setup focus trap when opening
            setupFocusTrap();
        } else {
            document.body.style.overflow= "auto";
            // Remove focus trap when closing
            removeFocusTrap();

            const submenues= document.querySelectorAll('.menu-mobile');
            submenues.forEach(element => {
                if (element.id !== 'main-mobile-menu') {
                    element.classList.remove("open");
                    element.setAttribute('inert', '');
                    element.setAttribute('aria-hidden', 'true');
                    
                    // Reset aria-expanded for buttons that triggered submenus
                    const trigger = document.querySelector(`[aria-controls="${element.id}"]`);
                    if (trigger) {
                        trigger.setAttribute('aria-expanded', 'false');
                    }
                }
            });
        }
    }

    const backSideMenu = (id) => {
        const menu_mobile = document.querySelector(`#${id}`)
        const trigger = document.querySelector(`[aria-controls="${id}"]`);
        const isOpen = menu_mobile.classList.contains("open");
        
        menu_mobile.classList.toggle("open");
        
        // Update inert and aria-hidden
        if (isOpen) {
            menu_mobile.setAttribute('inert', '');
            menu_mobile.setAttribute('aria-hidden', 'true');
        } else {
            menu_mobile.removeAttribute('inert');
            menu_mobile.setAttribute('aria-hidden', 'false');
        }
        
        if (trigger) {
            trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        }

        // Update focus trap to account for submenu visibility change
        if (document.querySelector('#main-mobile-menu.open')) {
            removeFocusTrap();
            setupFocusTrap();
        }
    }

    const nextSideMenu = (id) => {
        const menu_mobile = document.querySelector(`#${id}`)
        const trigger = document.querySelector(`[aria-controls="${id}"]`);
        const isOpen = menu_mobile.classList.contains("open");
        
        menu_mobile.classList.toggle("open");
        
        // Update inert and aria-hidden
        if (isOpen) {
            menu_mobile.setAttribute('inert', '');
            menu_mobile.setAttribute('aria-hidden', 'true');
        } else {
            menu_mobile.removeAttribute('inert');
            menu_mobile.setAttribute('aria-hidden', 'false');
        }
        
        if (trigger) {
            trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        }

        // Update focus trap to account for submenu visibility change
        if (document.querySelector('#main-mobile-menu.open')) {
            removeFocusTrap();
            setupFocusTrap();
        }
    }

    // Make functions globally accessible for inline onclick handlers
    window.toggleSideMenu = toggleSideMenu;
    window.backSideMenu = backSideMenu;
    window.nextSideMenu = nextSideMenu;

    // Language selector dropdown functionality
    const setupLanguageDropdown = () => {
        const dropdownButton = document.getElementById('language-selector-button');
        const dropdownMenu = document.getElementById('language-selector-menu');
        
        if (!dropdownButton || !dropdownMenu) return;

        let isOpen = false;

        const openDropdown = () => {
            isOpen = true;
            dropdownButton.setAttribute('aria-expanded', 'true');
            dropdownMenu.style.display = 'flex';
            const firstItem = dropdownMenu.querySelector('a');
            if (firstItem) firstItem.focus();
        };

        const closeDropdown = () => {
            isOpen = false;
            dropdownButton.setAttribute('aria-expanded', 'false');
            dropdownMenu.style.display = 'none';
        };

        const toggleDropdown = () => {
            if (isOpen) {
                closeDropdown();
            } else {
                openDropdown();
            }
        };

        // Button click handler
        dropdownButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleDropdown();
        });

        // Keyboard handler for button
        dropdownButton.addEventListener('keydown', (e) => {
            switch(e.key) {
                case 'Enter':
                case ' ':
                    e.preventDefault();
                    toggleDropdown();
                    break;
                case 'Escape':
                    if (isOpen) {
                        e.preventDefault();
                        closeDropdown();
                        dropdownButton.focus();
                    }
                    break;
                case 'ArrowDown':
                    if (!isOpen) {
                        e.preventDefault();
                        openDropdown();
                    }
                    break;
            }
        });

        // Keyboard navigation within menu
        dropdownMenu.addEventListener('keydown', (e) => {
            const items = Array.from(dropdownMenu.querySelectorAll('a'));
            const currentIndex = items.indexOf(document.activeElement);

            switch(e.key) {
                case 'Escape':
                    e.preventDefault();
                    closeDropdown();
                    dropdownButton.focus();
                    break;
                case 'ArrowDown':
                    e.preventDefault();
                    if (currentIndex < items.length - 1) {
                        items[currentIndex + 1].focus();
                    } else {
                        items[0].focus(); // Loop to first
                    }
                    break;
                case 'ArrowUp':
                    e.preventDefault();
                    if (currentIndex > 0) {
                        items[currentIndex - 1].focus();
                    } else {
                        items[items.length - 1].focus(); // Loop to last
                    }
                    break;
                case 'Tab':
                    // Allow natural Tab navigation, close only when tabbing out
                    const isLastItem = currentIndex === items.length - 1;
                    const isFirstItem = currentIndex === 0;
                    
                    if (!e.shiftKey && isLastItem) {
                        // Tabbing forward from last item - close and continue
                        closeDropdown();
                    } else if (e.shiftKey && isFirstItem) {
                        // Shift+Tab from first item - close and go back to button
                        e.preventDefault();
                        closeDropdown();
                        dropdownButton.focus();
                    }
                    // Otherwise, allow normal tab navigation within the dropdown
                    break;
            }
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', (e) => {
            if (isOpen && !dropdownButton.contains(e.target) && !dropdownMenu.contains(e.target)) {
                closeDropdown();
            }
        });
    };

    // Initialize language dropdown when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupLanguageDropdown);
    } else {
        setupLanguageDropdown();
    }

    // Focus trap functionality
    let focusTrapHandler = null;

    const getFocusableElements = (container) => {
        const selector = 'button:not([disabled]):not([inert]), a[href]:not([inert]), input:not([disabled]):not([inert]), select:not([disabled]):not([inert]), textarea:not([disabled]):not([inert]), [tabindex]:not([tabindex="-1"]):not([inert])';
        return Array.from(container.querySelectorAll(selector)).filter(el => {
            // Only include elements that are visible and not in closed submenus
            const isVisible = el.offsetWidth > 0 && el.offsetHeight > 0;
            const inClosedSubmenu = el.closest('.menu-mobile:not(.open):not(#main-mobile-menu)');
            return isVisible && !inClosedSubmenu;
        });
    }

    const setupFocusTrap = () => {
        const menu = document.querySelector('#main-mobile-menu');
        if (!menu) return;

        focusTrapHandler = (e) => {
            // Handle Escape key to close menu
            if (e.key === 'Escape') {
                e.preventDefault();
                if (menu.classList.contains('open')) {
                    toggleSideMenu();
                    // Return focus to menu button
                    const menuButton = document.querySelector(`[aria-controls="main-mobile-menu"]`);
                    if (menuButton) {
                        menuButton.focus();
                    }
                }
                return;
            }

            // Only trap Tab key
            if (e.key !== 'Tab') return;

            const focusableElements = getFocusableElements(menu);
            if (focusableElements.length === 0) return;

            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            if (e.shiftKey) {
                // Shift + Tab: if on first element, go to last
                if (document.activeElement === firstElement) {
                    e.preventDefault();
                    lastElement.focus();
                }
            } else {
                // Tab: if on last element, go to first
                if (document.activeElement === lastElement) {
                    e.preventDefault();
                    firstElement.focus();
                }
            }
        };

        document.addEventListener('keydown', focusTrapHandler);

        // Focus first element when menu opens
        setTimeout(() => {
            const focusableElements = getFocusableElements(menu);
            if (focusableElements.length > 0) {
                focusableElements[0].focus();
            }
        }, 100);
    }

    const removeFocusTrap = () => {
        if (focusTrapHandler) {
            document.removeEventListener('keydown', focusTrapHandler);
            focusTrapHandler = null;
        }
    }

    // Add event listeners to the menu items
    const menuItems = document.querySelectorAll('.menu-item');
    menuItems.forEach(item => {
        item.addEventListener('mouseover', (e) => {
            showDesktopMenu(e.target.dataset.id);
        });
        item.addEventListener('mouseleave', (e) => {
            if (header_menu_desktop) {
                const rect = header_menu_desktop.getBoundingClientRect();
                if (e.clientY < rect.top || e.clientX < rect.left || e.clientX > rect.right) {
                    hideDesktopMenu();
                }
            }
        });
    });

    const bigMenus = document.querySelectorAll('.menu-desktop');
    bigMenus.forEach(element => {
        element.addEventListener('mouseleave', (e) => {
            hideDesktopMenu();
        });
    });


    const hideDesktopMenu = () => {
        const menus_desktop = document.querySelectorAll(`.menu-desktop`)
        menus_desktop.forEach(element => {
            element.classList.remove("open");
        });
    }

    const hideThisDesktopMenu = (id) => {
        const menu_desktop = document.querySelector(`#menu-${id}`)
        menu_desktop.classList.remove("open");
    }

    const showDesktopMenu = (id) => {
        if (id === undefined) {
            return;
        };
        hideDesktopMenu();

        const menu_desktop = document.querySelector(`#menu-${id}`)
        menu_desktop.classList.add("open");
    }
})();